export const boxTransfersQueryKeys = {
  id: 'id',
  container: {
    id: 'container_id',
    name: 'container_name',
  },
  declaration: {
    id: 'declaration_id',
    trackCode: 'track_code',
  },
  fromContainer: {
    id: 'from_container_id',
    name: 'from_container_name',
  },
  toContainer: {
    id: 'to_container_id',
    name: 'to_container_name',
  },
  user: {
    id: 'user_id',
    name: 'user_name',
  },
  branch: {
    id: 'branch_id',
    name: 'branch_name',
  },
  note: 'note',
  createdAt: 'created_at',
};
